import React, {useContext, useEffect} from 'react'
import {Table} from 'antd'
import {TableDescription} from './TableDescription'
import {generateColumns} from './generateColumns'
import {transformData} from './transformData'
import {ReducerContext} from './reducer'
import DB from '../DAL/DB'

export default function Tables() {
  const {state, dispatch} = useContext(ReducerContext)
  
  // Determine aggregator type
  const aggType = state.dropdown.aggregation === 'reviewer' 
    ? 'reviewer' 
    : state.dropdown.aggregation === 'installer'
      ? 'installer'
      : 'field_user';
      
  const selectedUser = aggType === 'reviewer' 
    ? state.dropdown.reviewer 
    : aggType === 'installer'
      ? state.dropdown.installerUser
      : state.dropdown.fieldUser;

  useEffect(() => {
    const loadSOData = async () => {
      if (state.dropdown.rubric) {
        const aggregations = new DB.Aggregations()
        
        const {ok, data} = await aggregations.get(null, {
          filters: [
            [`rubric`, `==`, state.dropdown.rubric],
            [`aggregation_type`, `==`, aggType],
          ],
        })
        
        if (ok && data && data.length > 0) {
          dispatch({type: `SO_data`, value: data[0]})
        }
      }
    }
    
    loadSOData()
  }, [state.dropdown.rubric, aggType, state.dropdown.fieldUser, state.dropdown.reviewer, state.dropdown.installerUser])

  // convert data into table-ready format
  useEffect(
    function () {
      if (state.SO_data) {
        try {
          const transformedData = transformData(state.SO_data);
          dispatch({type: `final`, value: transformedData});
        } catch (error) {
          console.error("Error transforming SO_data:", error);
        }
      }
    },
    [state.SO_data]
  )

  if (!state.final) {
    return null;
  }

  // Filter dataSource by selected user (unless "All" or "select")
  const filterData = (data) => {
    if (!selectedUser || selectedUser === 'All' || selectedUser === 'select') return data;
    return data.filter(row => row[aggType] === selectedUser);
  };
  
  return (
    <div>
      <TableDescription betterOrWorse="better" />
      <Table
        columns={generateColumns({
          aggregationType: state.final?.aggregationType || '',
          betterOrWorse: `better`,
          columnWidths: {
            count: 90,
            third: 400
          },
          allUsers: state.allUsers
        })}
        dataSource={filterData(state.final?.better || [])}
        rowKey={(record) => record?.id || record?.[state.final?.aggregationType] || Math.random().toString()}
        scroll={{ x: 'max-content' }}
        bordered
        size="middle"
        style={{ marginBottom: 32 }}
      />
      <TableDescription betterOrWorse="worse" />
      <Table
        columns={generateColumns({
          aggregationType: state.final?.aggregationType || '',
          betterOrWorse: `worse`,
          columnWidths: {
            count: 90,
            third: 400
          },
          allUsers: state.allUsers
        })}
        dataSource={filterData(state.final?.worse || [])}
        rowKey={(record) => record?.id || record?.[state.final?.aggregationType] || Math.random().toString()}
        scroll={{ x: 'max-content' }}
        bordered
        size="middle"
      />
    </div>
  )
}
